<script>
import crud from '@/crud/form/form'
import resources from './resources'

export default {
  name: 'professional-covenants-edit',
  mixins: [crud, resources]
}
</script>

<template lang="pug">
page(title="Convênios Atendidos por Estabelecimento", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Convênio alterado com sucesso.',
          :buttonsNext='nextStepButtonCompanyCovenants',
          v-if="beenUpdated && userIsCompany")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Convênio alterado com sucesso.',
          :buttonsNext='nextStepButtonIsCompanyCovenants',
          v-if="beenUpdated && !userIsCompany")

        ul.nav.nav-tabs
          li
            router-link(:to="{ name: 'professional.company.covenants.index'}")
                a(href='#') Listagem
          li.active
            a(href='#') Cadastro
        .col-xs-12.white-bg
          .row
            .col-xs-12
              div.col-sm-10
                .space
                h4 ESTABELECIMENTO — CONVÊNIOS
                .form-group
                  label Covênio: {{ covenant.covenant.name }}

                .form-group
                  f-select-plan(
                    :get-all="true",
                    v-if="covenant.covenant_id", label="Plano de Saúde (opcional)", name="plans", v-model="covenant.plans",  :searchable="true",
                  :parameters="{company_covenant_id: covenant.id}"
                  :multiple="true",
                   :errors="errors['plan_id']")

                .form-group
                    f-select(label="Status",
                     name="active",
                     v-model="covenant.active",
                     :options="activeOptions",
                     :searchable="false",
                     :errors="errors['active']")

                .row.border-bottom
                .buttons-wrapper(v-if="!saved")
                  button.btn.save.pull-right(@click.prevent="doSave()")
                      span.icon 
                      |  Salvar Convênio
</template>



// WEBPACK FOOTER //
// src/app/professional/company/covenants/edit/edit.vue